<template>

	<button
		class="generated__code__copyBtn tooltip--wrap"
		@click="initCopy"
		@mouseleave="onMouseLeave"
	>
		<i class="fa fa-clone"></i>
		<span
			class="tooltip"
			:class="tooltipClass"
			v-show="!visibleCopied"
		>
			{{ $t('generated.tooltipCopy') }}
		</span>
		<span
			class="tooltip noHover"
			:class="{[tooltipClass]: tooltipClass, active: visibleCopied}"
		>
			{{ $t('generated.copied') }}
		</span>
	</button>
</template>

<script>

	export default {
		methods: {
			initCopy() {
				this.$emit('clickCopy');
			},
			onMouseLeave() {
				this.$emit('mouseleave')
			}
		},
		props: ['tooltipClass', 'visibleCopied']
	}

</script>